//@flow
import React from 'react';
import {useHistory} from 'react-router-dom';

import {IconButton, makeStyles, Typography} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import {classNames} from '../../utils/react';

type Props = {
  title: string,
  backButton?: boolean,
  backHref?: string,
  rightContent?: React$Node,
  classes?: {
    headerWrapper?: string,
    title?: string,
    backButton?: string,
  },
};

const useClasses = makeStyles(theme => ({
  headerWrapper: {
    maxWidth: 1300,
    background: '#f8f9fb',
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
}));

export default function PageHeader(props: Props) {
  const {
    backButton,
    title,
    backHref,
    rightContent,
    classes: propClasses,
  } = props;

  const classes = useClasses();
  const history = useHistory();

  const handleClickButtonBack = () => {
    if (!backHref) {
      history.goBack();
      return;
    }

    history.push(backHref);
  };

  return (
    <header
      className={classNames(classes.headerWrapper, propClasses?.headerWrapper)}
    >
      <Typography className={classes.title} id="organize-products-title">
        {backButton && (
          <IconButton
            className={classes.backButton}
            onClick={handleClickButtonBack}
          >
            <ArrowBack />
          </IconButton>
        )}

        {title}
      </Typography>

      {rightContent && <div>{rightContent}</div>}
    </header>
  );
}
